import React, { useEffect, useState } from 'react'
export default function Employee_prodectiviti() {
    const [employeeList, setEmployeeList] = useState([]);
    useEffect(() => {
        loadEmployeeProductivity();
    }, []);

    async function loadEmployeeProductivity() {
        try {
            let com_id = localStorage.getItem('mem_company_id');
            const response = await fetch(
                'getEmployeeProductivity.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        company_id: com_id
                    })
                }
            );
            const data = await response.json();
            setEmployeeList(data);
        } catch (error) {
            console.log(error);
        }

    }

    return (
        <div>
            <div className='fullwidth pb-30 pull_left'>
                <h3>Employee Productivity Table</h3>
                <p>
                    Performance table showing only about
                    the current month. It will show you
                    the work load per employee
                </p>
            </div>
            <div className='vl_listing_row'>
                <div className='vl_dsh_one_full'>
                    <table className='vl_task_table'>
                        <thead>
                            <tr>
                                <th>Employee Name</th>
                                <th>Active Task</th>
                                <th>Completed</th>
                                <th>Pending</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                employeeList.length > 0 ? (
                                    employeeList.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                {item.employee_name}
                                            </td>
                                          
                                            <td>
                                                {item.active_tasks} Active
                                            </td>
                                            <td>
                                                {item.complete_tasks} Completed
                                            </td>
                                            <td>
                                                {item.pending_tasks} Pending
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{textAlign: 'center',padding: '30px'}}>No employee found</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}